import { createFileRoute } from "@tanstack/react-router"
import { ResourceInstanceDetailPage } from "@/components/rema/resource-instances/ResourceInstanceDetailPage"

function ResourceInstanceDetailRoute() {
  const { instanceNumber } = Route.useParams()
  return (
    <div className="p-6">
      <ResourceInstanceDetailPage instanceNumber={instanceNumber} />
    </div>
  )
}

export const Route = createFileRoute("/rema/resource-instances/$instanceNumber")({
  staticData: {
    title: 'Resource Instance Detail',
    isSecured: true,
  },
  component: ResourceInstanceDetailRoute,
})
